import { MessageSwitcherProps } from '@/components/Loader/Loader';
import { TSimulationMenuOptions } from '@/store/types';
import { ReactNode, createContext, useState } from 'react';

export type SimulationParamsType = {
  factoryDataLoaded: boolean | null;
  simulationStarted: boolean;
  simulationForm: boolean;
  simulationOptionSelected: TSimulationMenuOptions;
  drawerOpen: boolean;
  formItem?: string;
  formArea?: TSimulationMenuOptions;
  loaderMessage: string | MessageSwitcherProps;
  selectedSites: string[];
};

const defaultSimulationParams: SimulationParamsType = {
  factoryDataLoaded: null,
  simulationStarted: false,
  simulationForm: false,
  simulationOptionSelected: 'scenario_settings',
  drawerOpen: false,
  formItem: undefined,
  loaderMessage: '',
  selectedSites: [],
};

/**
 * SimulationCtx Context
 * Provides default simulation parameters and functions to update them.
 * Includes parameters for factory data, simulation state, form state, and selected sites.
 */
export const SimulationCtx = createContext<{
  simulationParams: SimulationParamsType;
  setSimulationParams: React.Dispatch<
    React.SetStateAction<SimulationParamsType>
  >;
}>({
  simulationParams: defaultSimulationParams,
  setSimulationParams: () => {},
});

type SimulationProviderType = {
  children: ReactNode;
};

/**
 * SimulationProvider Component
 * Provides the SimulationCtx context to its children.
 * Manages the state for simulation parameters and updates them as needed.
 * @param {ReactNode} children - The child components to be wrapped by the provider
 */
export const SimulationProvider = ({ children }: SimulationProviderType) => {
  const [simulationParams, setSimulationParams] =
    useState<SimulationParamsType>(defaultSimulationParams);

  return (
    <SimulationCtx.Provider value={{ simulationParams, setSimulationParams }}>
      {children}
    </SimulationCtx.Provider>
  );
};
